import { type CanState, resolveCan } from 'shared';
import { useUserStore } from '~/modules/user/user-store';

/** `createdBy` as it appears on frontend entities: a user object, a bare id, or absent. */
type CreatedBy = string | { id: string } | null | undefined;

/** Resolves `true | false | 'own'` for one row; affordances with no row use `isUnconditionalCan`. */
export const useResolveCan = () => {
  const { user } = useUserStore();
  return (state: CanState | undefined, createdBy?: CreatedBy): boolean =>
    resolveCan(state, typeof createdBy === 'string' ? createdBy : (createdBy?.id ?? null), user?.id);
};
